import React, {useState} from 'react'
import * as Yup from 'yup'
import {useParams} from 'react-router-dom'
import {FormikHelpers, useFormik} from 'formik'
import {TextInput} from '../../../../_metronic/partials'
import clsx from 'clsx'
import {resetPassword} from '../redux/AuthCRUD'
import {isAxiosError} from '../../../../setup/axios/requests'
import {useHistory} from 'react-router-dom' // Import useHistory

const Schema = Yup.object().shape({
  email: Yup.string()
    .email('Format d\'e-mail incorrect')
    .min(12, 'Minimum 12 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('E-mail est obligatoire'),
  password: Yup.string()
    .min(8, 'Au moins 8 symboles')
    .max(50, 'Maximum 20 symboles')
    .required('Mot de passe requis'),
  passwordConfirmation: Yup.string()
    .min(8, 'Au moins 8 symboles')
    .max(50, 'Maximum 20 symboles')
    .required('Mot de passe requis')
    .oneOf([Yup.ref('password'), null], 'Les mots de passe ne sont pas identiques'),
  token: Yup.string()
    .min(30, 'Au moins 8 symboles'),
})

type initialValuesTypes = {
  email: string,
  password: string,
  passwordConfirmation: string,
  token: string,
}

interface SlugReset {
  slug: string;
  email: string;
}

export function ResetPassword() {

  const {slug, email}: SlugReset = useParams()
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)


  const onSubmit = async (values: initialValuesTypes, {
    setStatus,
    setSubmitting,
  }: FormikHelpers<initialValuesTypes>) => {
    setLoading(true)
    setHasErrors(undefined)
    setSubmitting(false)

    setTimeout(() => {
      resetPassword(values.email, values.password, values.passwordConfirmation, values.token)
        .then(({data: {status, messag: message}}) => {

          setStatus(message)
          setHasErrors(status === 500)
          setLoading(false)

          if (status === 200) {
            setTimeout(() => history.push('/login'), 1500)
          }
        })
        .catch((e) => {
          if (isAxiosError(e)) {
            const {message} = e.response?.data
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus(message)
          }
        })
    }, 1000)
  }
  const formik = useFormik({
    initialValues: {
      email,
      password: '',
      passwordConfirmation: '',
      token: slug,
    },
    validationSchema: Schema,
    enableReinitialize: true,
    onSubmit,
  })

  return (
    <>
      <form
        className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        noValidate
        id="kt_login_password_reset_form"
        onSubmit={formik.handleSubmit}
      >
        <div className="d-flex bg-light-info rounded border-info border border-dashed p-5 mb-10">
          <div className="text-info fs-7">
            <strong>Choisissez ici un nouveau mot de passe pour votre compte</strong>
          </div>
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className="mb-lg-15 alert alert-danger">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        )}

        {hasErrors === false && (
          <div className="mb-10 bg-light-info p-8 rounded">
            <div className="text-info">{formik.status}</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}

        <div className="fv-row mb-2 mb-lg-6">
          <label className="form-label col-form-label fw-bold fs-7">E-mail</label>
          <input placeholder="Email"
                 className={clsx(
                   'form-control form-control-sm form-control-solid mb-0',
                 )} type="email"
                 autoComplete="off"
                 {...formik.getFieldProps('email')}
                 readOnly
                 disabled
          />
        </div>

        <TextInput flex={'column'} formik={formik} name={'password'} label={'Mot de passe'} type={'password'} />
        <TextInput flex={'column'} formik={formik} name={'passwordConfirmation'} label={'Confirmation mot de passe'}
                   type={'password'} />

        {/* end::Form group */}

        {/* begin::Form group */}
        <div className="text-center mt-8">
          <button
            type="submit"
            id="kt_password_reset_submit"
            className="btn btn-lg btn-primary w-100 mb-5"
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className="indicator-label">Continue</span>}
            {
              loading && (
                <span className="indicator-progress" style={{display: 'block'}}>
                S'il vous plaît, attendez...{' '}
                  <span className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
              )}
          </button>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
